import Component from './component';
var utils = require('../utils');

/**
 * Colorswatch component
 */
export default class Colorswatch extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }


    toggleColorSwatch(showHide, $tileContainer, isMobile, colorSwatchConfig) {
        var $plusColors = $tileContainer.find('.swatch-plus-colors');
        var $moreColors = $tileContainer.find('.swatch-more-colors');
        var $item = $tileContainer.find('.swatch-item');

        if (showHide === 'show') {
            let desktopCount = colorSwatchConfig.desktopCount;
            var swatchContainerWidth = Math.floor($tileContainer.parent().width());
            // calculation for no of color swatches to display including the +more colors container width
            // +More colors container width including padding is 84,
            // hardcoded it as sometimes the conatiner gets shring on initial page load and does not give correct width
            var nofOfSwatches = Math.floor((swatchContainerWidth - 26) / 18);
            nofOfSwatches = (nofOfSwatches > desktopCount) ? desktopCount : nofOfSwatches;
            var availableSwatches = $tileContainer.data('totalcolors');
            var canAccomodate = false;
            // check if we can display the total available swatches, no need to display +More colors section
            if (availableSwatches <= desktopCount) {
                // calculating the required width for availableSwatches excluding the extra margin of 4 after the last color swatch
                canAccomodate = ((availableSwatches * 18) - 4) < swatchContainerWidth;
                nofOfSwatches = canAccomodate ? availableSwatches : nofOfSwatches;
            }

            $tileContainer.addClass('show');

            var setLeft = 3;
            var setTime = 0.1;

            if (isMobile) {
                setLeft += (22 * (colorSwatchConfig.mobileCount));
                nofOfSwatches = colorSwatchConfig.mobileCount;
            } else {
                setLeft += (22 * (nofOfSwatches));
            }

            for (let i = 0; i < nofOfSwatches; i++) {
                let $swatchItem = $($item[i]);

                if (!$swatchItem.hasClass('loaded')) {
                    let imageUrl = $swatchItem.data('image-url');
                    $swatchItem.css('background-image', `url('${imageUrl}')`);
                    $swatchItem.addClass('loaded');
                }

                if ($swatchItem.hasClass('d-none')) {
                    $swatchItem.removeClass('d-none');
                }

                $swatchItem.css('transition', 'all linear ' + String(setTime) + 's');
                setTime += 0.1;
            }

            if (canAccomodate && !isMobile) {
                $moreColors.addClass('d-none');
            }

            $moreColors.css('transition', 'all linear ' + String(setTime) + 's');
            $moreColors.css('left', String(setLeft) + 'px');
        } else {
            $tileContainer.removeClass('show');
            var i = 0;
            $item.each(function () {
                $(this).css('transition', 'all linear 0.' + String($item.length - i) + 's');
                i += 1;
            });
            $plusColors.css('transition', 'all linear 0.' + i + 's');
        }
    }


    enable() {
        const $swatchContainerElem = $('.swatch-container', this.$el);
        const componentSelector = `#${this.getComponentId()}`;
        const colorSwatchConfig = JSON.parse($('input[name*="colorSwatchConfig"]').val());
        const isMobile = this.getCurrentBreakpoint() === 'mobile';
        const showColorSwatchAlways = isMobile || colorSwatchConfig.exposeColorSwatch === true;

        // first time trigger to show the swatch
        if (showColorSwatchAlways) {
            this.toggleColorSwatch('show', $swatchContainerElem, isMobile, colorSwatchConfig);
        }

        $(document.body).on('mouseenter', componentSelector, (e) => {
            e.preventDefault();
            if (!showColorSwatchAlways) {
                this.toggleColorSwatch('show', $swatchContainerElem, isMobile, colorSwatchConfig);
            }
        });

        $(document.body).on('mouseleave', componentSelector, (e) => {
            e.preventDefault();
            if (!showColorSwatchAlways) {
                this.toggleColorSwatch('hide', $swatchContainerElem, isMobile, colorSwatchConfig);
            }
        });

        $(document).on('click keydown', `${componentSelector} .swatch-list .swatch-item`, function (e) {
            if (e.key === 'Enter' || e.type === 'click') {
                let $swatchList = $(this).closest('.swatch-list');
                $swatchList.find('.swatch-item').attr('aria-checked', 'false');
                $(this).attr('aria-checked', 'true');
                $(this).blur();
            }
        });

        $(document).on('click keydown', `${componentSelector} .swatch-item:not([disabled],[aria-checked="true"])`, function (e) {
            if (e.key === 'Enter' || e.type === 'click') {
                e.preventDefault();

                var $tileContainer = $(this).parents('.product-tile');
                $($tileContainer.find('.image-container')).css({ 'min-height': $tileContainer.find('.image-container').height() });
                var selectedValueUrl = $(this).attr('data-url');
                var data = $('.plp-img-container').data('product-image-attr');
                var searchRedirect;
                const hasData = !!data;
                if (hasData) {
                    searchRedirect = data.searchRedirect || false;
                }
                selectedValueUrl = utils.appendToUrl(selectedValueUrl, { swatchClick: true, searchRedirect: searchRedirect });
                $(document.body).trigger('swatch:clicked', [selectedValueUrl, $tileContainer]);
            }
        });
    }
}
